import React from 'react'
import { Helper } from '../../../../classes/helper'
import { useMeasures } from '../../../../hooks/state/useMeasures'
import { useSidewall } from '../../../../hooks/state/useSidewall'
import { Keys } from '../../../../hooks/state/utlility/utils'
import { roofTopBar } from '../model/helper/verandaDimensions'
import { WallSideGlass } from '../window/side/glass/WallSideGlass'
import { SideTie } from '../window/side/tie/SideTie'

export const WallTyp1 = (): JSX.Element => {
  const { userAngle, userHeight, angleCompensation, roofLogWidth } =
    useMeasures()
  const {
    plankHeight,
    sidwallTyp,
    type,
    sidewallIndex,
    spaceBetween,
    windowsSideTotal,
    windowsSideWidth,
    sideWall,
    spaceBetweenY,
    spaceY,
    isSidwallVsGlas,
    frameWall,
    cut,
    isWallCenter,
  } = useSidewall()

  const tieBottomTop = cut ? 2 : 1
  const name = (type ?? 'type') + (sidewallIndex ?? 0)

  const schraege = Helper.calculateTriangleSideLength(
    userAngle,
    90,
    sidwallTyp.log.depth
  ).a

  return (
    <group position={[0, sideWall.hasPlankWall ? plankHeight : 0, 0]}>
      {!cut && (
        <SideTie
          size={[
            sidwallTyp.log.depth,
            sidwallTyp.log.width,
            roofLogWidth + sidwallTyp.log.width,
          ]}
          rotation={[Helper.convertAngleToRadiant(userAngle), 0, 0]}
          key={`SideTieHorizontalschraege`}
          position={[
            0,
            spaceBetweenY - angleCompensation + sidwallTyp.log.width / 2,
            sidwallTyp.log.depth / 2,
          ]}
        />
      )}
      {[...Array(tieBottomTop)].map((_, index) => {
        return (
          <SideTie
            size={[
              sidwallTyp.log.depth,
              sidwallTyp.log.width,
              spaceBetween - sidwallTyp.log.width * (index ? 0 : 1),
            ]}
            rotation={[0, 0, 0]}
            key={`SideTieHorizontal${index}`}
            position={[
              0,
              index ? spaceBetweenY : sidwallTyp?.log?.width / 2,
              0,
            ]}
          />
        )
      })}

      {[...Array(2)].map((_, index) => {
        return (
          <SideTie
            size={[
              sidwallTyp.log.depth,
              cut
                ? spaceBetweenY
                : (index ? spaceY + sidwallTyp.log.width / 2 : userHeight) -
                  (sideWall.hasPlankWall ? plankHeight : 0) +
                  schraege,
              sidwallTyp.log.width,
            ]}
            rotation={[0, 0, 0]}
            key={`SideTieVertical${index}`}
            position={[
              0,
              (cut
                ? spaceBetweenY
                : (index ? spaceY + sidwallTyp.log.width / 2 : userHeight) -
                  (sideWall.hasPlankWall ? plankHeight : 0)) /
                2 +
                schraege,
              index
                ? spaceBetween / 2 - sidwallTyp.log.width / 2
                : (-spaceBetween + sidwallTyp.log.width) / 2,
            ]}
          />
        )
      })}

      {[...Array(windowsSideTotal)].map((_, index, array) => {
        const slantedHeight = !cut
          ? Math.tan((userAngle * Math.PI) / 180) *
              windowsSideWidth *
              Math.abs(index - windowsSideTotal) +
            spaceBetweenY +
            0.03
          : spaceBetweenY
        return (
          <React.Fragment key={index + name}>
            <WallSideGlass
              height={slantedHeight - sidwallTyp.log.width}
              cut={cut}
              windowsSideWidth={windowsSideWidth}
              key={`WallSideGlassWallTyp${index}`}
              position={[
                sidwallTyp.glas / 2,
                sidwallTyp.log.width,
                -(spaceBetween - windowsSideWidth) / 2 +
                  index * windowsSideWidth +
                  sidwallTyp.log.width / 2,
              ]}
              isGlass={isSidwallVsGlas}
              opacity={frameWall.windowColorBottom.opacity}
              roughness={frameWall.windowColorBottom.roughness}
              isOpal={
                frameWall.windowColorBottom.appearance ===
                Keys.GlasAuswahlOben.Values.Opal
              }
            />

            {index != array.length - 1 && (
              <SideTie
                size={[
                  sidwallTyp.log.depth,
                  slantedHeight -
                    (!isWallCenter
                      ? !cut
                        ? Math.tan((userAngle * Math.PI) / 180) *
                            windowsSideWidth +
                          sidwallTyp.log.width / 2 +
                          roofTopBar.height -
                          schraege
                        : 0
                      : 0),
                  sidwallTyp.log.width,
                ]}
                rotation={[0, 0, 0]}
                key={`SideTieVerticals${index}`}
                position={[
                  0,
                  (slantedHeight -
                    (!isWallCenter
                      ? cut
                        ? 0
                        : Math.tan((userAngle * Math.PI) / 180) *
                            windowsSideWidth -
                          sidwallTyp.log.width -
                          schraege
                      : 0)) /
                    2,
                  index * windowsSideWidth -
                    spaceBetween / 2 +
                    windowsSideWidth +
                    sidwallTyp.log.depth / 2,
                ]}
              />
            )}
          </React.Fragment>
        )
      })}
    </group>
  )
}
